// Objects on this layer feed the bloom pass (see Renderer.setBloom)
export const BLOOM_LAYER = 1

export default {
    exposure: 1,
    bloomThreshold: 0.33,
    bloomStrength: 0.8,
    bloomRadius: 0.6,
    // central cluster
    donutsAmount: 18,
    spheresAmount: 12,
    diamondAmount: 44,
    // outer orbiting field
    outerDonutsAmount: 70,
    outerSpheresAmount: 100,
    outerDiamondsAmount: 170,
    particlesAmount: 800, // 3000
    /**
     * Cursor repulsion. Things come to rest where the cursor's push balances
     * the spring pulling them home, which works out at roughly
     *
     *     strength * radius / (stiffness * radius + strength)
     *
     * so the numbers below sit each field at about 70% of its radius. Note
     * that raising `strength` on its own hits diminishing returns - the push
     * fades to nothing at the rim of the cone, so `angle` and `minRadius` are
     * what really set how far things travel. `maxOffset` is only a backstop.
     *
     * `angle` is the cone's half-angle as a tangent, and is the same for all
     * three on purpose: the cone widens with distance, so one value means the
     * cursor grabs the same sized disc on screen whether it's over the cluster
     * a few units away or the orbit field at eighty.
     */
    repulsion: {
        cluster: { strength: 40, angle: 0.38, minRadius: 3.2, stiffness: 3.5, maxOffset: 9 },
        outer: { strength: 120, angle: 0.38, minRadius: 8, stiffness: 2, maxOffset: 30 },
        particles: { strength: 60, angle: 0.38, minRadius: 3, stiffness: 4, maxOffset: 8 }
    },
    /**
     * Hover colour per string, keyed by the name passed to Text. The tint is
     * applied only to the blocks the cursor is swelling and fades out with the
     * swell, so it reads as the wave carrying the colour rather than the whole
     * word switching. A string with no entry here keeps its own colour.
     *
     * about and locations borrow contact's and work's colours: the old shared
     * blue was too close to their own to register as a change.
     *
     * Links only. The headline reads better holding its own colours, and a
     * string with no entry here skips the tint shader altogether.
     */
    textHover: {
        about: '#bd4500',
        locations: '#180052',
        contact: '#00c4eb',
        work: '#00c4eb'
    },
    /**
     * How much of its cell each block of the pixel font fills. The font's
     * squares tile edge to edge, so at 1 the blocks fuse into solid strokes and
     * the grid only shows where lighting catches an edge. Shrinking them
     * slightly opens a real gap between neighbours, which is what makes the
     * letters read as assembled blocks from any angle.
     *
     * It multiplies the swell's growth, so a block under the cursor closes its
     * gap as it rises and the wave reads as the letters knitting together.
     */
    textBlockFill: 0.94,
    /**
     * The swell the cursor raises in the 3D text, per block of the pixel font.
     * Everything but `response` is a multiple of the string's own size, so the
     * effect looks the same on 0.9-unit headings and 0.4-unit nav links.
     *
     * `radius` is the reach of the dome. At 2.2 it spans roughly three
     * characters, which is what gives neighbouring letters a partial rise
     * instead of one letter popping on its own.
     */
    textSwell: {
        radius: 2.2,
        // How much bigger a block gets at the peak, as a fraction. Blocks
        // already tile edge to edge, so all of this is overlap - past about
        // 0.5 the letterforms close up into a blob and stop being readable.
        grow: 0.4,
        // How far the peak lifts towards the viewer. Carries most of the
        // effect, since perspective enlarges the peak for free.
        bulge: 1.4,
        // Sideways opening around the peak, which keeps the shoulders of the
        // dome from packing together as they grow.
        spread: 0.45,
        // Approach rate, 1/s. Lower trails the cursor more.
        response: 14
    }
}